import { useMemo } from "react";
import { COMMON_WEB_PATH } from "../../../constant";
import { Box, Image } from "@chakra-ui/react";
import useCheckLogin from "../../../hook/useCheckLogin";
import { Link } from "react-router-dom";
import useDeviceType from "../../../hook/useDeviceType";

const UserButton = () => {
  const { isMachineUser } = useCheckLogin();

  const isMobile = useDeviceType() === "Mobile";

  const iconSize = useMemo(() => {
    return {
      base: "40px",
      md: "55px",
      xl: isMachineUser ? "62.5px" : "62.5px",
    };
  }, [isMachineUser]);

  return (
    <Box
      as={Link}
      to={isMobile ? "profile" : "profile/data"}
      position="relative"
      cursor="pointer"
      display="flex"
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Image
        src={`${COMMON_WEB_PATH}/theOne/header/user_icon.png`}
        height={iconSize}
        //minW="50px"
        minW={iconSize}
        maxW={iconSize}
      />
    </Box>
  );
};

export default UserButton;
